import { render, staticRenderFns } from "./interviewAddForm.vue?vue&type=template&id=5b61c21f&scoped=true"
import script from "./interviewAddForm.vue?vue&type=script&lang=js"
export * from "./interviewAddForm.vue?vue&type=script&lang=js"
import style0 from "./interviewAddForm.vue?vue&type=style&index=0&id=5b61c21f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61c21f",
  null
  
)

export default component.exports